import { ButtonProps, Icon, IconProps } from '@chakra-ui/react';
import { HiMiniWallet } from 'react-icons/hi2';
import { useWatchAsset } from 'wagmi';
import { RoundedButton } from './rounded-button';

type AddTokenToWalletProps = {
  tokenSymbol: string;
  tokenAddress: EthAddress;
  tokenDecimals: number | undefined;
  tokenImageUrl?: string;
  iconStyleProps?: IconProps;
  label?: string;
};

export const AddTokenToWalletButton = ({
  tokenSymbol,
  tokenAddress,
  tokenDecimals,
  label,
  tokenImageUrl,
  iconStyleProps = {},
  ...styleProps
}: AddTokenToWalletProps & ButtonProps) => {
  const { watchAsset } = useWatchAsset();
  const addTokenToWallet = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (!tokenDecimals) return;
    watchAsset({
      type: 'ERC20',
      options: {
        address: tokenAddress,
        symbol: tokenSymbol,
        decimals: tokenDecimals,
        image: tokenImageUrl,
      },
    });
  };
  return (
    <RoundedButton
      onClick={addTokenToWallet}
      variant="ghost"
      fontSize="sm"
      loading={tokenDecimals === undefined}
      loadingText={`Add ${tokenSymbol} to wallet`}
      _hover={{ bg: 'bg.muted' }}
      {...styleProps}
    >
      <Icon {...iconStyleProps}>
        <HiMiniWallet />
      </Icon>{' '}
      {label || `Add ${tokenSymbol} to wallet`}
    </RoundedButton>
  );
};
